export default "__VITE_ASSET__CZEJhxVl__"